export function getTranslation(languageString, langs) {
    if (languageString) {
        for (const lang of langs) {
            if (languageString?.[lang]) {
                return {
                    ok: true,
                    translation: languageString[lang],
                    isPrimaryLanguage: lang === langs[0],
                    language: lang,
                };
            }
        }
        for (const language in languageString) {
            return {
                ok: true,
                translation: languageString[language],
                isPrimaryLanguage: language === langs[0],
                language,
            };
        }
    }
    return {
        ok: false,
        translation: "",
    };
}
//# sourceMappingURL=language.js.map